import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { getListingsFacetsAsURLSearchParams } from './listings-api/getListingsFacetsAsURLSearchParams';
import { getListingsSortAsURLSearchParams } from './listings-api/getListingsSortAsURLSearchParams';

export const adaptStoreToPageURL = (
  state: ReduxApplicationState,
  page?: number,
): URLSearchParams => {
  const {
    productsQuery: { facets, searchTerm, sortOptions = [] },
  } = state;
  const urlParams = getListingsFacetsAsURLSearchParams(facets);

  const activeSortOption = sortOptions.find((option) => option.active);
  if (activeSortOption) {
    getListingsSortAsURLSearchParams(urlParams, activeSortOption);
  }

  // don't include page=1 as that is the default
  if (page && page > 1) {
    urlParams.set('page', page.toString());
  }

  if (searchTerm) {
    urlParams.set('term', searchTerm);
  }

  return urlParams;
};
